export const blockIconsPrivacyandsecurityNoEncryptionNew = (
	<span className='material-symbols-outlined'>no_encryption</span>
);
